import { Link } from 'react-router-dom';
import { getHotManhua, ManhuaItem } from '@/mocks/manhua';

function TrendingCard({ manhua }: { manhua: ManhuaItem }) {
  return (
    <Link
      to={`/manhua/${manhua.slug}`}
      className="flex-shrink-0 w-[220px] md:w-[260px] bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300 group"
    >
      <div className="aspect-[3/4] overflow-hidden">
        <img
          src={manhua.cover}
          alt={manhua.title}
          title={`${manhua.title} - 韩漫网热门推荐`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate">{manhua.title}</h3>
        <div className="flex items-center gap-2 mt-1.5">
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-xs text-amber-500"></i>
            <span className="text-xs font-medium text-foreground-600">{manhua.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{(manhua.views / 10000).toFixed(0)}万阅读</span>
        </div>
      </div>
    </Link>
  );
}

export default function TrendingSection() {
  const hotManhua = getHotManhua();

  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-4 py-1 border border-background-300/30 text-background-200 text-xs rounded-full mb-4">
              热门推荐
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50">
              本周最热门
            </h2>
          </div>
          <Link
            to="/category/all"
            className="hidden md:flex items-center gap-1 text-sm text-background-300 hover:text-primary-400 cursor-pointer whitespace-nowrap transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {hotManhua.map((manhua) => (
            <TrendingCard key={manhua.id} manhua={manhua} />
          ))}
        </div>

        <div className="mt-6 md:hidden text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-background-300 hover:text-primary-400 cursor-pointer transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}